import { getBadgeText, stringFormattingToCurrency } from "js/formatting";
import { RadioGroup } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

import CurrencyInput from "components/General/Form/CurrencyInput";
import FormInputError from "components/General/FormInputError";

const PanelThree = ({
  setIsDisabled,
  paymentType,
  selectedPolicy,
  setAmount,
  loan,
}) => {
  useEffect(() => {
    if (paymentType === "premiumpayment") {
      setIsDisabled(false);
    }
  }, [paymentType]);
  const { t } = useTranslation();
  const [value, setValue] = useState("");
  const [sectionThree, setSectionThree] = useState("");
  const [error, setError] = useState();
  const handleChange = (val) => {
    if (!val || val === "$") {
      setIsDisabled(true);
      setError(undefined);
    } else {
      let loanAmount = parseFloat(val?.replace("$", "").replace(",", ""));
      if (loanAmount > loan?.allProducts?.loanBalance) {
        setError(t("CustomerMakeAPayment-step-error"));
        setIsDisabled(true);
      } else if (loanAmount <= loan?.allProducts?.loanBalance) {
        setAmount(val);
        setError(undefined);
        setIsDisabled(false);
      }
    }
  };
  return (
    <>
      <div className="px-0 md:px-16">
        <form>
          <RadioGroup
            className="ui-form-card-row w-1/2"
            name="panelThreeSelection"
            value={sectionThree}
            onChange={setSectionThree}
          >
            {paymentType === "premiumpayment" ? (
              <RadioGroup.Option
                id="ID_paymentStep1Option1"
                className={({ checked }) =>
                  `${
                    checked || paymentType === "premiumpayment"
                      ? "ui-form-card selected"
                      : "ui-form-card"
                  }`
                }
                tabIndex="0"
                aria-label="Select to pay this policy"
                aria-controls="ID_paymentStep2Options"
                aria-expanded="false"
                disabled={
                  parseFloat(selectedPolicy?.modalPremiumAmountTotal) <= 0 ||
                  !selectedPolicy?.modalPremiumAmountTotal
                }
                onClick={() => {
                  setIsDisabled(false);
                }}
                value="monthly"
              >
                {({ checked }) => (
                  <>
                    <RadioGroup.Label
                      className="block text-xxs mb-1 pr-8 cursor-pointer font-semibold"
                      as="p"
                    >
                      {`${t("CustomerMakeAPayment-step-three-policy-number")}${
                        selectedPolicy.oldPolicy
                      }`}
                    </RadioGroup.Label>

                    <RadioGroup.Label className="block text-xxs text-ui-gray-default pr-8 cursor-pointer font-semibold">
                      <div className="flex justify">
                        <svg
                          className={`ui-icon w-4 h-4 mr-2 self-center text-ui-${
                            getBadgeText(selectedPolicy).includes("Past due")
                              ? "red"
                              : "green"
                          }`}
                          focusable="false"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <use href="#ui-icon-circle-solid-exclamation"></use>
                        </svg>
                        <p className="self-center font-semibold">
                          {getBadgeText(selectedPolicy).includes("Past due")
                            ? t("CustomerMakeAPayment-step-three-past-due")
                            : t("CustomerMakeAPayment-step-three-paid-to-date")}
                          {stringFormattingToCurrency(
                            selectedPolicy?.modalPremiumAmountTotal
                          )}
                        </p>
                      </div>
                    </RadioGroup.Label>
                    <div className="text-xxs font-semibold pr-8 group-hover:underline">
                      <div className="ui-form-card-checkbox">
                        <svg
                          className="ui-icon w-2 h-2 text-white hidden"
                          focusable="false"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <use href="#ui-icon-checkmark"></use>
                        </svg>
                      </div>
                    </div>
                  </>
                )}
              </RadioGroup.Option>
            ) : (
              <>
                <RadioGroup.Option
                  id="ID_paymentStep1Option1"
                  className={({ checked }) =>
                    `${checked ? "ui-form-card selected" : "ui-form-card"}  `
                  }
                  tabIndex="0"
                  aria-label="Select to pay this policy"
                  aria-controls="ID_paymentStep2Options"
                  aria-expanded="false"
                >
                  {({ checked }) => (
                    <>
                      <RadioGroup.Label
                        className="block text-xxs mb-1 pr-8 cursor-pointer font-semibold"
                        as="p"
                      >
                        {`Policy # ${selectedPolicy?.oldPolicy}`}
                      </RadioGroup.Label>

                      <RadioGroup.Label className="block text-xxs text-ui-gray-default pr-8 cursor-pointer font-semibold">
                        <div className="mt-4 relative">
                          <CurrencyInput
                            value={value}
                            onChange={handleChange}
                          />
                          {error && (
                            <FormInputError
                              id={`loamAmount`}
                              errorMessage={error}
                            />
                          )}
                        </div>
                      </RadioGroup.Label>
                      <div className="text-xxs font-semibold pr-8 group-hover:underline">
                        <div className="ui-form-card-checkbox">
                          <svg
                            className="ui-icon w-2 h-2 text-white hidden"
                            focusable="false"
                            aria-hidden="true"
                            role="presentation"
                          >
                            <use href="#ui-icon-checkmark"></use>
                          </svg>
                        </div>
                      </div>
                    </>
                  )}
                </RadioGroup.Option>
              </>
            )}
          </RadioGroup>
        </form>
      </div>
    </>
  );
};

export default PanelThree;
